export default "__VITE_ASSET__5hJ2b4Bw__"